var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_66_412)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 149.5,
    height: 149.5,
    rx: 11.75,
    stroke: "#4A4A4A",
    strokeOpacity: 0.75,
    strokeWidth: 0.5,
    strokeDasharray: "1 1"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.25,
    x2: 0.25,
    y2: 149.382,
    stroke: "#4A4A4A",
    strokeOpacity: 0.75,
    strokeWidth: 0.5,
    strokeDasharray: "1 1"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.0402,
    x2: 15.0402,
    y2: 149.382,
    stroke: "#4A4A4A",
    strokeOpacity: 0.75,
    strokeWidth: 0.5,
    strokeDasharray: "1 1"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 29.8307,
    x2: 29.8307,
    y2: 149.382,
    stroke: "#4A4A4A",
    strokeOpacity: 0.75,
    strokeWidth: 0.5,
    strokeDasharray: "1 1"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 44.6209,
    x2: 44.6209,
    y2: 149.382,
    stroke: "#4A4A4A",
    strokeOpacity: 0.75,
    strokeWidth: 0.5,
    strokeDasharray: "1 1"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 59.4114,
    x2: 59.4114,
    y2: 149.382,
    stroke: "#4A4A4A",
    strokeOpacity: 0.75,
    strokeWidth: 0.5,
    strokeDasharray: "1 1"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 74.2015,
    x2: 74.2015,
    y2: 149.382,
    stroke: "#4A4A4A",
    strokeOpacity: 0.75,
    strokeWidth: 0.5,
    strokeDasharray: "1 1"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 90.4709,
    x2: 90.4709,
    y2: 149.382,
    stroke: "#4A4A4A",
    strokeOpacity: 0.75,
    strokeWidth: 0.5,
    strokeDasharray: "1 1"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 105.262,
    x2: 105.262,
    y2: 149.382,
    stroke: "#4A4A4A",
    strokeOpacity: 0.75,
    strokeWidth: 0.5,
    strokeDasharray: "1 1"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120.052,
    x2: 120.052,
    y2: 149.382,
    stroke: "#4A4A4A",
    strokeOpacity: 0.75,
    strokeWidth: 0.5,
    strokeDasharray: "1 1"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 134.842,
    x2: 134.842,
    y2: 149.382,
    stroke: "#4A4A4A",
    strokeOpacity: 0.75,
    strokeWidth: 0.5,
    strokeDasharray: "1 1"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 149.632,
    x2: 149.632,
    y2: 149.382,
    stroke: "#4A4A4A",
    strokeOpacity: 0.75,
    strokeWidth: 0.5,
    strokeDasharray: "1 1"
  }), /*#__PURE__*/React.createElement("line", {
    y1: 134.342,
    x2: 150.861,
    y2: 134.342,
    stroke: "#4A4A4A",
    strokeOpacity: 0.75,
    strokeWidth: 0.5,
    strokeDasharray: "1 1"
  }), /*#__PURE__*/React.createElement("line", {
    y1: 119.552,
    x2: 150.861,
    y2: 119.552,
    stroke: "#4A4A4A",
    strokeOpacity: 0.75,
    strokeWidth: 0.5,
    strokeDasharray: "1 1"
  }), /*#__PURE__*/React.createElement("line", {
    y1: 104.761,
    x2: 150.861,
    y2: 104.761,
    stroke: "#4A4A4A",
    strokeOpacity: 0.75,
    strokeWidth: 0.5,
    strokeDasharray: "1 1"
  }), /*#__PURE__*/React.createElement("line", {
    y1: 89.9709,
    x2: 150.861,
    y2: 89.9709,
    stroke: "#4A4A4A",
    strokeOpacity: 0.75,
    strokeWidth: 0.5,
    strokeDasharray: "1 1"
  }), /*#__PURE__*/React.createElement("line", {
    y1: 75.1807,
    x2: 150.861,
    y2: 75.1807,
    stroke: "#4A4A4A",
    strokeOpacity: 0.75,
    strokeWidth: 0.5,
    strokeDasharray: "1 1"
  }), /*#__PURE__*/React.createElement("line", {
    y1: 60.3905,
    x2: 150.861,
    y2: 60.3905,
    stroke: "#4A4A4A",
    strokeOpacity: 0.75,
    strokeWidth: 0.5,
    strokeDasharray: "1 1"
  }), /*#__PURE__*/React.createElement("line", {
    y1: 45.6,
    x2: 150.861,
    y2: 45.6,
    stroke: "#4A4A4A",
    strokeOpacity: 0.75,
    strokeWidth: 0.5,
    strokeDasharray: "1 1"
  }), /*#__PURE__*/React.createElement("line", {
    y1: 30.8097,
    x2: 150.861,
    y2: 30.8097,
    stroke: "#4A4A4A",
    strokeOpacity: 0.75,
    strokeWidth: 0.5,
    strokeDasharray: "1 1"
  }), /*#__PURE__*/React.createElement("line", {
    y1: 16.0194,
    x2: 150.861,
    y2: 16.0194,
    stroke: "#4A4A4A",
    strokeOpacity: 0.75,
    strokeWidth: 0.5,
    strokeDasharray: "1 1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_66_412"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    rx: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid);
export default __webpack_public_path__ + "static/media/grid.a834d1ad7dcecb92123b1a223709944d.svg";
export { ForwardRef as ReactComponent };